import React from 'react';

const PosNegociacaoContext = React.createContext();

export default PosNegociacaoContext;